import { Link } from "react-router-dom";
import "./searchInput.css";
import { getItemIconUrl } from "@/client/util/wowhead";

const ItemResult = ({
    itemId,
    name,
    quality,
    icon,
}: {
    itemId: number;
    name: string;
    quality: number;
    icon: string;
}): JSX.Element => {
    return (
        <Link to={`/item/${itemId}`} className="itemSearchResultItem">
            <img className="itemIcon itemSearchResultIcon" src={getItemIconUrl(icon, "medium")}></img>
            <span className={`itemQuality${quality} itemSearchResultName`}>{name}</span>
        </Link>
    );
};

export default ItemResult;
